<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      // api: "http://192.168.0.104:5267",
      // api:'http://localhost:21055',
      // api:'http://1.14.72.77:5000',
      api:'http://8.137.125.59:5000',
      //  headers: {
      //   // 每次访问 Authorization 时，实时读取 localStorage
      //   get Authorization() {
      //     return localStorage.getItem('Authorization') || '';
      //   }
      // }
      // headers: { Authorization: localStorage.getItem("Authorization") },
    };
  },
};
</script>
<style>
* {
  box-sizing: border-box;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.table-header {
  padding: 10px;
  border-bottom: 1px solid #e6e6e6;
}
.el-dialog__body {
  padding: 10px 20px;
}
.common-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: transparent;
  padding: 0;
  min-width: 800px;
}
.common-header-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  background: #fff;
  padding: 0 16px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 60px;
  color: #303133;
}
.header-title-text {
  font-size: 18px;
  color: #303133;
  padding-left: 15px;
}
.common-header .el-page-header__left {
  align-items: center;
}
.common-header .el-page-header__content {
  line-height: 0.5;
}
.header-content {
  display: inline-flex;
  align-items: center;
}
.header-logo {
  width: 32px;
  height: 32px;
  margin-right: 12px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue